import { render, staticRenderFns } from "./BusinessDocumentDetailPage.vue?vue&type=template&id=fcf49a36&"
import script from "./BusinessDocumentDetailPage.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf49a36')) {
      api.createRecord('fcf49a36', component.options)
    } else {
      api.reload('fcf49a36', component.options)
    }
    module.hot.accept("./BusinessDocumentDetailPage.vue?vue&type=template&id=fcf49a36&", function () {
      api.rerender('fcf49a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentDetailPage.vue"
export default component.exports